import DiscardContractDialog from './DiscardContractDialog';

export default DiscardContractDialog;
